<template>
  <div class="discuss_wrap" v-loading="loading" :style="'height:'+height">
    <div class="menu-toggle" :class="{ 'menu-open': !menuFlag }" @click="toggleMenu"></div>
    <div class="discuss_left" v-if="menuFlag">
      <ul>
        <li
         v-for="(item,index) in list" 
         :key="index"
         @click="tab(index)"
         :class="{active : index===tabIndex}">
          <a class="list-group-item list-group-item-action">
            <i :class="item.class" :style="'background:url('+item.src+') no-repeat;background-size:100%'"/>
            <p>{{item.name}}</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="discuss_right">
      <alldiscuss v-if="tabIndex == 0"></alldiscuss>
      <teacherdiscuss v-if="tabIndex == 1"></teacherdiscuss>
      <studentdiscuss v-if="tabIndex == 2"></studentdiscuss>
    </div>  
  </div>
</template>

<script>
	import alldiscuss from './discuss/allDiscuss/allDiscuss.vue'
	import teacherdiscuss from './discuss/teacherDiscuss/teacherDiscuss.vue'
	import studentdiscuss from './discuss/studentDiscuss/studentDiscuss.vue'
  export default {
    name: "discuss",
    inject: ['reload'],
    components: {
    	alldiscuss,
    	teacherdiscuss,
    	studentdiscuss
    },
    data(){
      return{
        menuFlag: true,
        loading: false,
        list:[{
          src:'../../../../../static/images/study/icon/quanbutl_hv.png',
          name: '全部讨论区',
          class: 'all'
        },
        {
          src:'../../../../../static/images/study/icon/laoshiday_hv.png',
          name: '老师答疑区',
          class: 'teacher'
        },
        {
          src:'../../../../../static/images/study/icon/ketangjl_hv.png',
          name: '课堂交流区',
          class: 'student'
        }],
        tabIndex: 0,
        height:window.innerHeight - 236+"px"
      }
    },
    created(){
//    if(this.$route.path=='/courseAdmin/discuss'){
//      this.$router.push({
//        path:'/courseAdmin/discuss/all',
//        query:{
//          id:this.$route.query.courseId
//        }
//      })
//    }
    },
    mounted(){
      $(".container-header").hide();
      if(this.$route.path.split('/')[1]=='courseAdmin'){
        this.list = [
          {
            src:'../../../../../static/images/study/icon/quanbutl_hv.png',
            name: '全部讨论区',
            path: '/courseAdmin/discuss/all',
            class: 'all'
          },
          {
            src:'../../../../../static/images/study/icon/laoshiday_hv.png',
            name: '老师答疑区',
            path: '/courseAdmin/discuss/teacher',
            class: 'teacher'
          },
          {
            src:'../../../../../static/images/study/icon/ketangjl_hv.png',
            name: '课堂交流区',
            path: '/courseAdmin/discuss/student',
            class: 'student'
          }
        ]
      }
    },
    methods: {
      toggleMenu() {
        this.menuFlag = !this.menuFlag;
      },
      tab(index){
        this.tabIndex = index;
//      this.reload();
      }
    },
  }
</script>

<style lang="scss" scoped>
  .discuss_wrap{
    width: 100%;
    display: flex;
    .discuss_left{
      width:160px;
      height: calc(100% - 32px);
      border-radius:0px 4px 4px 0px;
      ul{
        li{
          width:160px;
          height:40px;
          text-align: center;
          cursor: pointer;
          border-radius: 2px;
          a{
            height:40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          i{
            display: block;
            width: 16px;
            height: 16px;
          }
          p{
            font-size:14px;
            font-weight:400;
            color:rgba(102,102,102,1);
            margin-left: 6px;
          }
        }
        li.active {
        	background: #5397F7;
        	p {
        		color: #fff;
        	}
        	.all{
            background: url('../../../../../static/images/study/icon/quanbutl.png') !important;
            background-size: 100% !important;
          }
          .teacher{
            background: url('../../../../../static/images/study/icon/laoshidy.png') !important;
            background-size: 100% !important;
          }
          .student{
            background: url('../../../../../static/images/study/icon/ketangjl.png') !important;
            background-size: 100% !important;
          }
        }
      }
    }
    .discuss_right{
      flex: 1;
    }
    .menu-toggle {
      position: fixed;
      top: 50%;
      left: 200px;
      width: 16px;
      height: 64px;
      margin-top: -32px;
      cursor: pointer;
      /*background: url("../../img/close.png");*/
      background-size: 100% 100%;
    }
    .menu-open {
      left: 0;
      /*background: url("../../img/close_right.png");*/
      background-size: 100% 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/components/discussAnswer.vue